import React from 'react';
import Reveal from './Reveal';

// Manufacturing highlight cards — continuously auto-scrolling strip (same
// left-moving marquee transition used across the site), one card per
// highlight. These are placeholder photos for now — swap the `img` on each
// card below for the real workshop / shop-floor photos once they're shared;
// the strip, sizes and text will keep working exactly the same way.
import factoryHero from '../assest/manufacturing/factory-floor-hero.jpg';
import tTransformer2 from '../assest/transformer/transformer_2.jpg';
import pSteelPole from '../assest/product image transparent/Steel_Tubular_Poles.png.png';
import pControlPanel from '../assest/product image transparent/Control_Panels_and_Distribution_Panel.png.png';

const cards = [
  {
    key: 'floor',
    img: factoryHero,
    tag: 'Barauni Workshop',
    title: 'BUILT AT OUR OWN FACTORY IN BIHAR',
    size: 'w-[300px] sm:w-[360px]',
  },
  {
    key: 'transformer',
    img: tTransformer2,
    tag: 'Transformer Line',
    title: 'IN-HOUSE TRANSFORMER WINDING & ASSEMBLY',
    size: 'w-[260px] sm:w-[300px]',
  },
  {
    key: 'structures',
    img: pSteelPole,
    tag: 'Steel Fabrication',
    title: 'CUSTOM STEEL POLE FABRICATION',
    size: 'w-[300px] sm:w-[360px]',
  },
  {
    key: 'panels',
    img: pControlPanel,
    tag: 'Panel Assembly',
    title: 'CONTROL PANEL BUILD & WIRING',
    size: 'w-[260px] sm:w-[300px]',
  },
  {
    key: 'qc',
    img: factoryHero,
    tag: 'Quality Control',
    title: 'TESTED BEFORE IT LEAVES OUR FLOOR',
    size: 'w-[300px] sm:w-[360px]',
  },
];

function Card({ c }) {
  return (
    <div className={`relative ${c.size} shrink-0 overflow-hidden rounded-2xl`}>
      <div className="aspect-[4/5]">
        <img src={c.img} alt={c.title} className="h-full w-full object-cover" loading="lazy" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/25 to-navy/10" />
      <div className="absolute inset-0 flex flex-col justify-between p-5">
        <span className="inline-block w-max rounded-full bg-white/10 px-3 py-1 text-[10px] font-bold uppercase tracking-wide text-white/85 backdrop-blur">
          {c.tag}
        </span>
        <h3 className="text-xl font-black uppercase leading-[1.05] text-white sm:text-2xl">{c.title}</h3>
      </div>
    </div>
  );
}

export default function ManufacturingGallery() {
  const loop = [...cards, ...cards];

  return (
    <section className="overflow-hidden bg-slate-50 py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <span className="inline-block rounded-full bg-brand-orange/10 px-4 py-1 text-xs font-bold uppercase tracking-wide text-brand-orange">
            Inside The Workshop
          </span>
          <h2 className="mt-3 text-2xl font-extrabold text-navy sm:text-3xl">
            A look at where it&rsquo;s built
          </h2>
        </Reveal>
      </div>

      <Reveal delay={120} className="mt-10">
        <div className="marquee-track gap-5 pl-4 sm:pl-6 lg:pl-8">
          {loop.map((c, i) => (
            <Card key={`${c.key}-${i}`} c={c} />
          ))}
        </div>
      </Reveal>
    </section>
  );
}
